import { createContext, useContext } from "react"
import Toast from "../components/Toast"
import ConfirmDialog from "../components/ConfirmDialog"
import { useToast } from "../hooks/useToast"
import { useConfirm } from "../hooks/useConfirm"

/**
 * Shared toast + confirm-dialog access for every admin screen, so admin actions
 * give the same accessible, styled feedback as the public Trust Center instead
 * of native alert()/confirm()/prompt(). Wrap each admin route's element with
 * this provider (see App.jsx) — it owns the state and renders the UI once.
 */
const AdminFeedbackContext = createContext(null)

export function AdminFeedbackProvider({ children }) {
    const { toasts, toast, removeToast } = useToast()
    const { confirmState, confirm, handleConfirm, handleCancel } = useConfirm()

    return (
        <AdminFeedbackContext.Provider value={{ toast, confirm }}>
            <Toast toasts={toasts} onRemove={removeToast} />
            <ConfirmDialog state={confirmState} onConfirm={handleConfirm} onCancel={handleCancel} />
            {children}
        </AdminFeedbackContext.Provider>
    )
}

export function useAdminFeedback() {
    const ctx = useContext(AdminFeedbackContext)
    if (!ctx) {
        throw new Error("useAdminFeedback must be used within an AdminFeedbackProvider")
    }
    return ctx
}
